import { Component, OnInit, OnDestroy } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { trigger, transition, style, animate } from '@angular/animations';
import { SystemNotificationDto } from 'app/api/models';
import { NotificationStackService } from './notification-stack.service';

@Component({
    selector: 'notification-stack',
    imports: [MatButtonModule, MatIconModule],
    template: `
        <div class="notification-stack-container">
          @for (notification of notifications; track notification; let i = $index) {
            <div
              class="notification-item"
              [style.bottom.px]="i * 90"
              @slideIn>
              <div class="notification-content">
                <div class="notification-message" [innerHTML]="formatMessage(notification.content)"></div>
                <div class="notification-actions">
                  <button mat-button (click)="onView(notification)">View</button>
                  <button mat-icon-button (click)="onDismiss(notification)">
                    <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
        `,
    styles: [`
        .notification-stack-container {
            position: fixed;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 9999;
            pointer-events: none;
        }

        .notification-item {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            min-width: 400px;
            max-width: 600px;
            pointer-events: all;
        }

        .notification-content {
            background-color: #323232;
            color: white;
            padding: 16px;
            border-radius: 4px;
            box-shadow: 0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12);
            display: flex;
            align-items: center;
            gap: 16px;
        }

        .notification-message {
            flex: 1;
            font-size: 14px;
            line-height: 20px;
        }

        .notification-message ::ng-deep p {
            margin: 0;
            padding: 2px 0;
        }

        .notification-message ::ng-deep strong {
            font-weight: 600;
        }

        .notification-message ::ng-deep .text-sm {
            font-size: 12px;
            opacity: 0.9;
        }

        .notification-actions {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .notification-actions button {
            color: var(--fuse-primary);
        }

        .notification-actions mat-icon {
            width: 20px;
            height: 20px;
            font-size: 20px;
        }
    `],
    animations: [
        trigger('slideIn', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateX(-50%) translateY(20px)' }),
                animate('300ms ease-out', style({ opacity: 1, transform: 'translateX(-50%) translateY(0)' }))
            ]),
            transition(':leave', [
                animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(-50%) translateY(20px)' }))
            ])
        ])
    ]
})
export class NotificationStackComponent implements OnInit, OnDestroy {
    notifications: SystemNotificationDto[] = [];

    constructor(private notificationStackService: NotificationStackService) {}

    ngOnInit(): void {
        this.notificationStackService.notifications$.subscribe(notifications => {
            this.notifications = notifications;
        });
    }

    ngOnDestroy(): void {
        // Cleanup if needed
    }

    formatMessage(content: string): string {
        return content || 'New notification';
    }

    onView(notification: SystemNotificationDto): void {
        this.notificationStackService.handleView(notification);
    }

    onDismiss(notification: SystemNotificationDto): void {
        this.notificationStackService.dismiss(notification);
    }
}
